import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(({ spacing, zIndex }) => ({
  container: ({ controlsStyles }: { controlsStyles: any }) => ({
    position: 'absolute',
    top: `calc(50% + ${spacing(9)}px)`,
    right: spacing(2),
    transform: 'translateY(-50%)',
    zIndex: `${zIndex.mobileStepper} !important`,
    ...controlsStyles
  })
}));
